/**
 * Direkt GA4 via gtag.js (Measurement ID i index.html).
 * Om du även lägger samma ID i GTM → risk för dubbla sidvisningar/events; använd bara ett spår.
 */
const MEASUREMENT_ID =
  process.env.REACT_APP_GA4_MEASUREMENT_ID?.trim() || "G-P7TGGP4R9W";

function gtagReady(): boolean {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

/** SPA: sidvisning efter första laddning (första sköts av gtag config i index.html). */
export function ga4SendSpaPageView(): void {
  if (!gtagReady()) return;
  window.gtag!("config", MEASUREMENT_ID, {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function ga4SendEcommerceEvent(
  eventName: string,
  params: Record<string, unknown>
): void {
  if (!gtagReady()) return;
  window.gtag!("event", eventName, params);
}
